module.exports = __webpack_public_path__ + "static/media/TermsAndConditonsNOD.a3c971d6.pdf";